/**
 * @generated SignedSource<<abfdbb4beaafb1983d18420bf9d10fbc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertUserDataInput = {
  name: string;
  type: string;
  value: string;
};
export type UpsertUserDataMutation$variables = {
  input: UpsertUserDataInput;
};
export type UpsertUserDataMutation$data = {
  readonly upsertUserData: {
    readonly userData: {
      readonly id: string;
      readonly name: string;
      readonly type: string;
      readonly value: string;
    };
  };
};
export type UpsertUserDataMutation = {
  response: UpsertUserDataMutation$data;
  variables: UpsertUserDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertUserDataPayload",
    "kind": "LinkedField",
    "name": "upsertUserData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertUserDataMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpsertUserDataMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "8fa01f2ed64bda05bcf15862e6b2bcbb",
    "id": null,
    "metadata": {},
    "name": "UpsertUserDataMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertUserDataMutation(\n  $input: UpsertUserDataInput!\n) {\n  upsertUserData(input: $input) {\n    userData {\n      id\n      name\n      type\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "822e59c643ded5bb64f2e5dc91e261ef";

export default node;
